$(document).ready(function(){
    $(document).on("click",".block__about-bark-description-btn",function(){
        var data_id = $(this).attr("data-id");
        $(".block__about-box-popups#"+data_id).addClass("active_popup");
        $("body").addClass("overflow-hidden");
        $(".block__popup-overlay").removeClass("hidden");
    });

    $(document).on("click",".block__about-box-popups-close,.block__popup-overlay",function(){
        $(".block__about-box-popups").removeClass("active_popup");
        $("body").removeClass("overflow-hidden");
        $(".block__popup-overlay").addClass("hidden");
    });
});